<template>
  <div class="wrapper">
  <div><img src="./assets/v5.png" style="width: 400px; margin-top: 64px; padding-bottom: 32px;"></div>
  <HelloWorld v-if=$route.params.roomId />
  <div v-else style="text-align: left; margin-left: 30%; margin-right: 30%">
  <h1>▣ WHAT IS WEBDUET?</h1>
  <p><i>In a nutshell...</i></p>
  <h2><i>Connect two MIDI pianos over the internet, at the click of a button</i></h2>
  <p>Ever wanted to play piano over the internet with someone else on an actual piano? Got a good piano-playing friend that lives far from you? Well, these are basically situations where this little website can come in handy!</p>

  <p>WebDuet creates a peer-to-peer connection between you and another person with the same URL. It uses WebRTC for this, and sends raw MIDI data back-and-forth over the established data channel.</p>

  <h1>▣ HOW TO USE IT?</h1>

  <p>Before being able to play, there are two prerequisites: 
    <ul>
        <li>You need a <b>MIDI keyboard/piano</b> that can produce <b>sound</b>, and it has to be <b>connected</b> to the computer (usually via a <a target="_blank"  href="https://www.cmd-ltd.com/advice-centre/usb-chargers-and-power-modules/usb-and-power-module-product-help/identifying-usb-connector/">USB-A to USB-B cable</a>)</li>
        <li>The WebMIDI part only works in <b>chromium-based browsers</b>, so for now you need to do this in chrome, edge, etc. Firefox support will come once they implement WebMIDI as well.</li>
    </ul>
  </p>


  <p>Once this is OK, using WebDuet is simple: just go to a URL of your choice under this domain (e.g. webduet.net/blabla), and then give this URL to your piano buddy. Then, when both of you have finished loading the page, one of you has to click the "connect" button. If it turns <b style="color: green;">green</b>, you two are connected!</p>

  <p>WebDuet will automatically select the first MIDI input device that is connected to your computer, and match the MIDI output to this device as well. This basically means that whenever your piano buddy plays something, you'll hear it come out of your piano, and vice versa. You can  adjust the device if necessary, by selecting a different one from the drop-downs.</p>

  <p>
  If you don't actually have a MIDI piano, you can still play a little bit on your computer keyboard (starting at the "A" key). If you have a MIDI output device, it will be selected automatically, though not all devices are capable of making sound. In case you need one that can, you can always install <a target="_blank"  href="https://coolsoft.altervista.org/en/virtualmidisynth">Virtual MIDI Synth</a>. It will allow you to play back MIDI with instrument packs of choice, which come in the form of <a target="_blank"  href="https://en.wikipedia.org/wiki/SoundFont">.sf2</a> files. Many can be found online, <a target="_blank" href="https://github.com/urish/cinto/blob/master/media/FluidR3%20GM.sf2">this one</a> is quite nice to start with, but you can find more for instance <a target="_blank"  href="https://musical-artifacts.com/artifacts?formats=sf2&order=most_downloaded&tags=gm">here</a>. Note that this MIDI device will only give you output, the input is something you need to take care of on your own, either with a MIDI keyboard/piano, or by simply playing on the computer keyboard.
  </p>


  <h1>▣ ISSUES AND WORKAROUNDS</h1>
    <ul>
        <li>Nothing here yet..</li>
    </ul>

  </div>
  </div>
    <footer role="contentinfo">
        <small>Copyright &copy; {{year}} Shaad Alaka</small>
    </footer>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  },
  computed: {
    year() {
        return new Date().getFullYear();
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;

  display: grid;
  grid-template-rows: 1fr auto;
  grid-template-areas: 
    "wrapper"
    "footer";

}
html, body {
  height: 100%;
  margin: 0px;
}


.wrapper {
    grid-area: wrapper;
}

@font-face {
    font-family: maven;
    src: url('./assets/fonts/Maven.otf');
}

h1 {
    font-family: maven;
    font-size: 48px;
    padding-top: 30px;
}


p, li, h2 {
    font-family: calibri;
    font-size: 22px;
}

h2 {
    text-align: center;
    font-size: 24px;
}
li {
    padding-bottom: 10px;
}
footer {
    grid-area: footer;
    height: 24px;
    background-color: #eeeeee;
    vertical-align: middle;
    line-height: 24px;
}


</style>
